<div class="kpi-trend-container">
  <ng-container *ngIf="trendConfig as config; else noIndicator">
    <mat-icon
      [svgIcon]="config.icon"
      class="kpi-trend-icon"
      [style.color]="config.color"
    ></mat-icon>
    <span class="kpi-trend-change" [style.color]="config.color" *ngIf="hasTrendChange">{{
      trendChangeDisplay
    }}</span>
  </ng-container>

  <ng-template #noIndicator>
    <span class="kpi-trend-change" *ngIf="hasTrendChange">{{ trendChangeDisplay }}</span>
  </ng-template>
</div>
